// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dxZDI1IuuqsFg7S6 .BYAZyTuj2pk6NYxG{display:flex;align-items:center;padding:8px;color:var(--py-neutral-4);line-height:16px;border-radius:4px;min-height:16px;word-break:break-word}.dxZDI1IuuqsFg7S6 .BYAZyTuj2pk6NYxG:hover{color:var(--py-neutral-10);background-color:var(--py-neutral-1);border-radius:4px}.dxZDI1IuuqsFg7S6 .BYAZyTuj2pk6NYxG.AnikZzT88Qw3e33w{color:var(--py-neutral-10);border-right:3px;border-style:solid;border-color:var(--py-primary-5);background-color:var(--py-neutral-1)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageControlsContainer": `dxZDI1IuuqsFg7S6`,
	"pageControlsItem": `BYAZyTuj2pk6NYxG`,
	"active": `AnikZzT88Qw3e33w`
};
export default ___CSS_LOADER_EXPORT___;
